import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {},
  title: {
    marginBottom: theme.spacing(3)
  },
  group: {
    '& + &': {
      marginTop: theme.spacing(4)
    }
  },
  activity: {
    position: 'relative',
    '& + &': {
      marginTop: theme.spacing(3),
      '&:before': {
        position: 'absolute',
        content: '" "',
        height: 20,
        width: 1,
        top: -20,
        left: 20,
        backgroundColor: theme.palette.divider
      }
    }
  }
}));

function Checks({ claim, className, ...rest }) {
  const classes = useStyles();

  const formatMoney = amount => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    return formatter.format(amount);
  };

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Card>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} />
            <Grid item xs={12}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Check Type</TableCell>
                    <TableCell>Issue Date</TableCell>
                    <TableCell>Number</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Payee</TableCell>
                    <TableCell>Voided</TableCell>
                    <TableCell>Transmission Date</TableCell>
                    <TableCell>Accounting Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {claim.checks?.map(check => {
                    return (
                      <TableRow key={`check${check.CheckTypeIDX}`}>
                        <TableCell>{check.checkTypeIdx}</TableCell>
                        <TableCell>
                          {moment(check.issueDate).format('L')}
                        </TableCell>
                        <TableCell>{check.checkNumber}</TableCell>
                        <TableCell>{formatMoney(check.checkAmount)}</TableCell>
                        <TableCell>{check.additionalInfo}</TableCell>
                        <TableCell>{check.voidFlag ? 'Yes' : 'No'}</TableCell>
                        <TableCell>
                          {check.transmissionDate
                            ? moment(check.transmissionDate).format('L')
                            : ''}
                        </TableCell>
                        <TableCell>
                          {moment(check.acctDate).format('L')}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

Checks.propTypes = {
  userRoles: PropTypes.arrayOf(PropTypes.string),
  claim: PropTypes.object,
  allowOverrides: PropTypes.bool,
  className: PropTypes.string
};

export default Checks;
